// import React, { useState, Fragment } from "react";
// import $ from "jquery";
// import "../contact.css";
// import "jquery-ui-dist/jquery-ui";
// import { Link } from "react-router-dom";
// import  { useNavigate } from "react-router-dom";


// const Contact = () => {
//   const [status, setStatus] = useState("Submit");
//   const navigate = useNavigate();

 
//   const [info, setInfo] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     message: "",
//   });
//   const nameRegex = /^[a-zA-Z\s]+$/;
//   const phoneRegex = /^\d{10}$/;
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   const handleChange = (event) => {
//     setInfo({
//       ...info,
//       [event.target.name]: event.target.value,
//     });
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     console.log(info);
//     setStatus("Sending...");

//     let response = await fetch(`/api/contactuspage`, {
//       method: "POST",
//       headers: {
//         "Access-Control-Allow-Origin": "*",
//         Accept: "application/json",
//         //'Content-Type': 'application/json',
//         "Content-Type": "application/json;charset=utf-8",
//       },
      
//       body: JSON.stringify(info),
//       //body: JSON.stringify(details),
//     });
//     navigate("/ThankYou");
//     //console.log(details);
//     console.log(info);
//     setStatus("Submit");
    
//     setInfo({ name: "", phone: "", email: "", state: "", message: "" });
//     let result = await response.json();
   
//     alert(result.status);
//   };

//   return (
//     <Fragment>
//       <div>
//         <img
//           src="img/slide1.jpeg"
//           alt="Slide Image"
//           className="img-fluid w-100"
//           style={{ height: "300px", maxWidth: "1500px", objectFit: "cover" }}
//         />
//         <nav aria-label="breadcrumb" className="mt-3">
//           <ol className="breadcrumb">
//             <li className="breadcrumb-item">
//               <Link to="/home">Home</Link>
//             </li>
//             <li className="breadcrumb-item active" aria-current="page">
//               Contact
//             </li>
//           </ol>
//         </nav>
//       </div>{" "}
//       <section className="contact">
//         <h1
//           className="section-header"
//           style={{ textAlign: "center", color: "white" }}
//         >
//           Contact
//         </h1>

//         <div className="contact-wrapper">
//           <form
//             id="contact-form"
//             className="form-horizontal "
//             role="form"
//             onSubmit={handleSubmit}
//           >
//             <div className="form-group  ">
//               <div className="col-sm-12">
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="name"
//                   name="name"
//                   pattern="[a-zA-Z\s]+"
//                   placeholder="Name"
//                   value={info.name}
//                   onChange={handleChange}
//                   style={{ backgroundColor: "white", color: "black" }}
//                   required
//                 />
//               </div>
//             </div>
//             <div className="form-group">
//               <div className="col-sm-12">
//                 <input
//                   type="email"
//                   name="email"
//                   className="form-control"
//                   placeholder="Email"
//                   pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
//                   value={info.email}
//                   onChange={handleChange}
//                   style={{ backgroundColor: "white", color: "black" }}
                  
//                 />
//               </div>
//             </div>
//             <div className="form-group">
//               <div className="col-sm-12">
//                 <input
//                   type="text"
//                   name="phone"
//                   className="form-control"
//                   id="phone"
//                   placeholder="Phone"
//                   pattern="\d{10}"
//                   value={info.phone}
//                   onChange={handleChange}
//                   style={{ backgroundColor: "white", color: "black" }}
//                   required
//                 />
//               </div>
//             </div>


//              <div className="form-row">
//                           <div className="form-group col-6">
//                             <label className="control-label">State</label>
//                             <select
//                               id="states"
//                               name="states"
//                               className="form-control"
//                               required=""
//                             >
//                               <option value="">SELECT STATE</option>
//                               <option value="2">Andhra Pradesh</option>
//                               <option value="5">Bihar</option>
//                               <option value="12">Gujarat</option>
//                               <option value="13">Haryana</option>
//                               <option value="14">Himachal Pradesh</option>
//                               <option value="16">Jharkhand</option>
//                               <option value="17">Karnataka</option>
//                                                             <option value="17">Kerala</option>

//                               <option value="21">Maharashtra</option>
//                               <option value="28">Punjab</option>
//                               <option value="29">Rajasthan</option>
//                               <option value="31">Tamil Nadu</option>
//                               <option value="32">Telangana</option>
//                               <option value="35">Uttar Pradesh</option>
//                             </select>
//                           </div>
//                           {/* <div className="form-group col-6 city">
//                             <label className="control-label">Center</label>
//                             <select
//                               name="city"
//                               id="city"
//                               className="form-control center"
//                               required=""
//                             >
//                               <option value="">SELECT CENTRE</option>
//                             </select>
//                           </div> */}
//                         </div>

//             {/* <div className="form-group">
//               <div className="col-sm-12">
//                 <input
//                   type="text"
//                   name="phone"
//                   className="form-control"
//                   id="phone"
//                   placeholder="Phone"
//                   pattern="\d{10}"
//                   value={info.phone}
//                   onChange={handleChange}
//                   style={{ backgroundColor: "white", color: "black" }}
//                   required
//                 />
//               </div>
//             </div> */}
           
//             <textarea
//               className="form-control"
//               rows="10"
//               placeholder="Message"
//               name="message"
//               value={info.message}
//               onChange={handleChange}
//               style={{
//                 height: "100px",
//                 backgroundColor: "white",
//                 color: "black",
//                 marginTop:'10px'
//               }}
//               required
//             ></textarea>

//             <button
//               className="btn btn-primary send-button"
//               id="submit"
//               type="submit"
//               value="SEND"
//             >
//               {status}
//             </button>
//           </form>

//           <div className="direct-contact-container">
//             <ul className="contact-list">
//               <li className="list-item d-flex my-2 align-items-start">
//                 <i className="fa fa-map-marker fa-2x"></i>
//                   <span className="contact-text text-white place">
                   
//                     First floor Shersha Arcade, Vetturoad JN, Kaniyapuram P. O. ZIP Code: 695301
//                   </span>
                
//               </li>

//               <li className="list-item d-flex my-3 align-items-start">
//                 <i className="fa fa-phone fa-2x "></i>
//                   <span className="contact-text text-white phone">
//                     <a
//                       href="tel:1-212-555-5555"
//                       title="Give me a call"
//                       className="text-white"
//                     >
//                       {" "}
//                       <b>8089657171/9900502404</b>
//                     </a>
//                   </span>
                
//               </li>

//               <li className="list-item d-flex my-3 align-items-start">
//                 <i className="fa fa-envelope fa-2x"></i>
//                   <span className="contact-text text-white gmail">
//                     <a
//                       href="mailto:caddeskkaniyapuram@gmail.com"
//                       title="Send me an email"
//                       className="text-white"
//                     >
//                        caddeskkaniyapuram@gmail.com
//                     </a>
//                   </span>
               
//               </li>
//             </ul>

//             <ul className="social-media-list">
//               <a
//                   href="https://www.instagram.com/_caddesk_kaniyapuram_/?hl=en"
//                   target="_blank"
                  
//                 >
//               <li className="contact-icon">
                
//                   <i className="fab fa-instagram text-danger" aria-hidden="true"></i>
              
//               </li>
//                 </a>

//                 <a
//                   href="https://www.facebook.com/people/Caddesk-kaniyapuram/61587576802972/"
//                   target="_blank"
                  
//                 >
//               <li className="contact-icon">
                
//                   <i className="fab fa-facebook-f text-info" aria-hidden="true"></i>
               
//               </li>
//                </a>
//             </ul>
//             <div></div>
//           </div>
//         </div>
//       </section>
//     </Fragment>
//   );
// };

// export default Contact;


import React, { useState, Fragment } from "react";
import $ from "jquery";
import "../contact.css";
import "jquery-ui-dist/jquery-ui";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Captcha } from "./Captcha"; // adjust path as needed


const Contact = () => {
  const [status, setStatus] = useState("Submit");
  const navigate = useNavigate();
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const [info, setInfo] = useState({
    name: "",
    phone: "",
    email: "",
    state: "",
    message: "",
  });

  const nameRegex = /^[a-zA-Z\s]+$/;
  const phoneRegex = /^\d{10}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (event) => {
    setInfo({
      ...info,
      [event.target.name]: event.target.value,
    });
  };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!captchaVerified) {
//       alert("Please verify the CAPTCHA before submitting.");
//       return;
//     }

//     console.log(info);
//     setStatus("Sending...");

//     // let response = await fetch(`/api/contactuspage`, {
//     //   method: "POST",
//     //   headers: {
//     //     "Access-Control-Allow-Origin": "*",
//     //     Accept: "application/json",
//     //     "Content-Type": "application/json;charset=utf-8",
//     //   },
//     //   body: JSON.stringify(info),
//     // });
// let response = await fetch(`/api/contactuspage`, {
//   method: "POST",
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//   },
//   body: JSON.stringify(info),
// });

// let result = await response.json();

// if (result.status === "Message Sent") {
//   navigate("/ThankYou");
// } else {
//   alert("Failed to send");
// }
//     navigate("/ThankYou");
//     console.log(info);
//     setStatus("Submit");
//     setCaptchaVerified(false);
//     setInfo({ name: "", phone: "", email: "", state: "", message: "" });

//     let result = await response.json();
//     alert(result.status);
//   };


const handleSubmit = async (e) => {
  console.log("FORM SUBMITTED"); 
  e.preventDefault();

  if (!captchaVerified) {
    alert("Please verify the CAPTCHA before submitting.");
    return;
  }

  setStatus("Sending...");

  try {
    let response = await fetch("/api/contactuspage", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(info),
    });

    let result = await response.json();
    console.log("RESULT:", result);

    if (result.status === "Message Sent") {
      navigate("/ThankYou");
    } else {
      alert("Failed to send");
    }

  } catch (error) {
    console.error("ERROR:", error);
    alert("Server error");
  }

  setStatus("Submit");
  setCaptchaVerified(false);
  setInfo({ name: "", phone: "", email: "", state: "", message: "" });
};
  return (
    <Fragment>
      <div>
        <img
          src="img/slide1.webp"
          alt="Slide Image"
          className="img-fluid w-100"
           style={{ height: "300px"}}
        />
        <nav aria-label="breadcrumb" className="mt-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/home">Home</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Contact
            </li>
          </ol>
        </nav>
      </div>{" "}

      <section className="contact">
        <h1
          className="section-header"
          style={{ textAlign: "center", color: "white" }}
        >
          Contact
        </h1>

        <div className="contact-wrapper">
          <form
            id="contact-form"
            className="form-horizontal"
            role="form"
            onSubmit={handleSubmit}
          >
            <div className="form-group">
              <div className="col-sm-12">
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  
                  placeholder="Name"
                  value={info.name}
                  onChange={handleChange}
                  style={{ backgroundColor: "white", color: "black" }}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <div className="col-sm-12">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Email"
                 
                  value={info.email}
                  onChange={handleChange}
                  style={{ backgroundColor: "white", color: "black" }}
                />
              </div>
            </div>

            <div className="form-group">
              <div className="col-sm-12">
                <input
                  type="text"
                  name="phone"
                  className="form-control"
                  id="phone"
                  placeholder="Phone"
                 
                  value={info.phone}
                  onChange={handleChange}
                  style={{ backgroundColor: "white", color: "black" }}
                  required
                />
              </div>
            </div>

            {/* State Dropdown */}
            <div className="form-group">
              <div className="col-sm-12">
                <select
                  id="state"
                  name="state"
                  className="form-control"
                  value={info.state}
                  onChange={handleChange}
                  style={{ backgroundColor: "white", color: "black" }}
                  required
                >
                  <option value="">SELECT STATE</option>
                  <option value="Andhra Pradesh">Andhra Pradesh</option>
                  <option value="Bihar">Bihar</option>
                  <option value="Gujarat">Gujarat</option>
                  <option value="Haryana">Haryana</option>
                  <option value="Himachal Pradesh">Himachal Pradesh</option>
                  <option value="Jharkhand">Jharkhand</option>
                  <option value="Karnataka">Karnataka</option>
                  <option value="Kerala">Kerala</option>
                  <option value="Maharashtra">Maharashtra</option>
                  <option value="Punjab">Punjab</option>
                  <option value="Rajasthan">Rajasthan</option>
                  <option value="Tamil Nadu">Tamil Nadu</option>
                  <option value="Telangana">Telangana</option>
                  <option value="Uttar Pradesh">Uttar Pradesh</option>
                </select>
              </div>
            </div>

            {/* Message */}
            <textarea
              className="form-control"
              rows="10"
              placeholder="Message"
              name="message"
              value={info.message}
              onChange={handleChange}
              style={{
                height: "100px",
                backgroundColor: "white",
                color: "black",
                marginTop: "10px",
              }}
              required
            ></textarea>

            {/* CAPTCHA — after message field */}
            <div style={{ marginTop: "14px" }}>
              <Captcha onVerified={(verified) => setCaptchaVerified(verified)} />
            </div>

            <button
              className="btn btn-primary send-button"
              id="submit"
              type="submit"
              value="SEND"
            >
              {status}
            </button>
          </form>

          <div className="direct-contact-container">
            <ul className="contact-list">
              <li className="list-item d-flex my-2 align-items-start">
                <i className="fa fa-map-marker fa-2x"></i>
                <span className="contact-text text-white place">
                  First floor Shersha Arcade, Vetturoad JN, Kaniyapuram P. O. ZIP Code: 695301
                </span>
              </li>

              <li className="list-item d-flex my-3 align-items-start">
                <i className="fa fa-phone fa-2x"></i>
                <span className="contact-text text-white phone">
                  <a
                    href="tel:1-212-555-5555"
                    title="Give me a call"
                    className="text-white"
                  >
                    {" "}
                    <b>8089657171/9900502404</b>
                  </a>
                </span>
              </li>

              <li className="list-item d-flex my-3 align-items-start">
                <i className="fa fa-envelope fa-2x"></i>
                <span className="contact-text text-white gmail">
                  <a
                    href="mailto:caddeskkaniyapuram@gmail.com"
                    title="Send me an email"
                    className="text-white"
                  >
                    caddeskkaniyapuram@gmail.com
                  </a>
                </span>
              </li>
            </ul>

            <ul className="social-media-list">
              <a
                href="https://www.instagram.com/_caddesk_kaniyapuram_/?hl=en"
                target="_blank"
              >
                <li className="contact-icon">
                  <i className="fab fa-instagram text-danger" aria-hidden="true"></i>
                </li>
              </a>

              <a
                href="https://www.facebook.com/people/Caddesk-kaniyapuram/61587576802972/"
                target="_blank"
              >
                <li className="contact-icon">
                  <i className="fab fa-facebook-f text-info" aria-hidden="true"></i>
                </li>
              </a>
            </ul>
            <div></div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Contact;